import { render } from "./ListTray.vue?vue&type=template&id=2be83626"
import script from "./ListTray.vue?vue&type=script&lang=js"
export * from "./ListTray.vue?vue&type=script&lang=js"

import "./ListTray.vue?vue&type=style&index=0&id=2be83626&lang=css"
script.render = render

export default script